import { render, staticRenderFns } from "./RightMenuElement.vue?vue&type=template&id=3ad8faca&scoped=true"
import script from "./RightMenuElement.vue?vue&type=script&lang=js"
export * from "./RightMenuElement.vue?vue&type=script&lang=js"
import style0 from "./RightMenuElement.vue?vue&type=style&index=0&id=3ad8faca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad8faca",
  null
  
)

export default component.exports